<template>
  <div class="liming">
    <MainHeader>
      {{$ml.get('Liming')}}
    </MainHeader>
    <HeadLine>
      {{$ml.get('info')}}
    </HeadLine>
    <div class="info th-fields-container">
      <div class="column">
        <ValueField :label="$ml.get('Current pH')" :value="section.CurrentPh"/>
        <ValueField :label="$ml.get('Buffer pH')" :value="section.BufferPh"/>
        <ValueField :label="$ml.get('Months from last application')" :value="section.MonthsSinceLastApp + ' ' + $ml.get('months')"/>
        <ValueField :label="$ml.get('OM (Organic Matter)')" :value="section.OM + '%'"/>
        <ValueField :label="$ml.get('Layer Depth')" :value="$store.getters['unit/convert']('cm_inch', section.PlowDepth) + ' ' + $store.getters['unit/getLabel']('cm_inch')"/>
      </div>
      <div class="column">
        <ValueField :label="$ml.get('Target pH')" :value="section.TargetPh"/>
        <ValueField :label="$ml.get('Exchangeble Acidity')" :value="section.ExcAcidity"/>
        <ValueField :label="$ml.get('Amount Last Application')" :value="section.AmountLastApp"/>
        <ValueField :label="$ml.get('Buld density')" :value="$store.getters['unit/convert']('g/cm3', section.BulkDensity) + ' ' + $store.getters['unit/getLabel']('g/cm3')"/>
        <ValueField :label="$ml.get('Material name')" :value="$ml.get(section.material.MaterialName)"/>
      </div>
    </div>

    <HeadLine>
      {{$ml.get('Material specification')}}
    </HeadLine>
    <table class="th-table science">
      <tr>
        <td></td>
        <td>{{$ml.get('CCE')}}</td>
        <td>{{$ml.get('Ca')}}</td>
        <td>{{$ml.get('ENV')}}</td>
        <td>{{$ml.get('Moisture')}}</td>
        <td>{{$ml.get('Pass60')}}</td>
        <td>{{$ml.get('Pass6to80')}}</td>
      </tr>
      <tr>
        <td></td>
        <td>{{ section.material.CCE }}%</td>
        <td>{{ section.material.CaPer }}%</td>
        <td>{{ section.material.ENV.toFixed(2) }}%</td>
        <td>{{ section.material.Moisture }}%</td>
        <td>{{ section.material.Pass60 }}%</td>
        <td>{{ section.material.Pass6to80 }}%</td>
      </tr>
    </table>

    <HeadLine>
      {{$ml.get('result')}}
    </HeadLine>
    <div class="result">
      <div class="item">
        <div class="label">
          {{$ml.get('Lime requirement')}}: 
        </div>
        <div class="value">
          {{ parseFloat($store.getters['unit/convert']('T', section.result.LimingAdjustModel.LimeRequirement)).toFixed(2) }} {{$ml.get($store.getters['unit/getLabel']('T'))}}
        </div>
      </div>
      <div class="item">
        <div class="label">
          {{$ml.get('Material to apply')}}: 
        </div>
        <div class="value">
          {{ parseFloat($store.getters['unit/convert']('T', section.result.LimingAdjustModel.MaterialToApplay)).toFixed(2) }} {{$ml.get($store.getters['unit/getLabel']('T'))}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from './../components/common/MainHeader';
import HeadLine from './../components/common/HeadLine';
import ValueField from './../components/common/ValueField';

export default {
  components: {
    MainHeader,
    ValueField,
    HeadLine,
  },
  computed: {
    section() {
      return this.$root.data.liming;
    }
  },
}
</script>

<style lang="scss" scoped>

.liming {
  .head-line {
    margin-bottom: 10px;
  }

  .info {
    padding-bottom: 20px;
  }

  .science {
    td {
      &:first-child {
        padding: 0;
      }
    }
  }

  .result {

    display: flex;
    flex-direction: row;
    align-items: stretch;

    .item {
      .label {
        font-weight: bold;
        font-size: 15px;
        border-bottom: 1px solid #C4C4C4;
      }

      .value {
        font-size: 15px;
      }

      > * {
        margin-right: 50px;
        padding: 10px 0;
        text-align: left;
      }
    }
  }
}

</style>